import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';

export const passwordResetCheckingUser = t.type({
  id: t.number,
  name: t.string,
  email: t.string,
  organization: t.string,
  expiresAt: DateFromUnixTime,
});
